<template>
  <span v-if="text" :class="['sc-countdown', `sc-${kind}`]">{{ text }}</span>
</template>

<script>
import { computed } from 'vue';
import { trialDaysLeft as computeDaysLeft } from '../../shared/trial';

// P2 (2026-09-19), D6 — ONE countdown for the two things that end on a date:
//   kind="trial"   the free trial        (reads the org's trialEndsAt)
//   kind="ending"  a scheduled cancel    (reads the org's subscriptionEndsAt)
// Both are Firestore Timestamps on the org document, and both count calendar
// days through shared/trial's day count. That is the count the trial banner
// always used, so the two can't disagree about what "3 days" means.
//
// Wording (D5): a subscription ENDS ON A DATE. It is never "cancelled".
//
// Renders nothing when the date is missing or unreadable. The caller decides
// WHETHER a countdown applies; this only says how long is left.
export default {
  props: {
    endsAt: { default: null },
    kind: { type: String, required: true, validator: (v) => v === 'trial' || v === 'ending' },
    // Injectable for tests. Defaults to the real clock.
    now: { default: null },
  },
  setup(props) {
    const daysLeft = computed(() => {
      if (!props.endsAt) return null;
      return computeDaysLeft(props.endsAt, props.now || new Date());
    });

    const text = computed(() => {
      const d = daysLeft.value;
      if (d === null || d === undefined) return '';
      if (props.kind === 'trial') {
        if (d <= 0) return '';
        return d === 1 ? '1 day left in trial' : `${d} days left in trial`;
      }
      // kind === 'ending'
      if (d < 0) return '';
      if (d === 0) return 'Subscription ends today';
      return d === 1 ? 'Subscription ends in 1 day' : `Subscription ends in ${d} days`;
    });

    return { text };
  },
};
</script>
